import { useEffect } from "react";

const useMatchHeight = (className: string, loading?: boolean) => {
	useEffect(() => {
		const matchHeight = () => {
			setTimeout(() => {
				const els = document.querySelectorAll(className);
				if (els.length < 1) return;

				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				const elsHeight: any[] = [];
				for (let i = 0; i < els.length; i += 1) {
					(els[i] as HTMLElement).style.height = "auto";
					elsHeight.push(els[i].clientHeight);
				}
				for (let i = 0; i < els.length; i += 1) {
					(els[i] as HTMLElement).style.height = `${Math.max(...elsHeight)}px`;
				}
			}, 200);
		};
		if (!loading) {
			setTimeout(() => {
				matchHeight();
			}, 200);
		}
		window.addEventListener("resize", matchHeight);
		return () => {
			window.removeEventListener("resize", matchHeight);
		};
	}, [className, loading]);
};

export default useMatchHeight;
